import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { camelToDisplay } from '@iotv/datamodel';
import { Input, Slider, TableCell, TableRow } from '@mui/material';
const debug = process.env.REACT_APP_DEBUG && false;
export function SimpleNumberRow({ desiredPayload, setDesiredPayload, setHasEdits, k, v, currentValue, limits, min, max, marks, step, keyWidth, inputWidth, i, }) {
    const handleNumberChange = (e, k) => {
        const value = parseInt(e.target.value);
        const { attributeType, range: { min, max }, } = limits;
        debug && console.log('limits', limits);
        if (value >= min && value <= max) {
            setDesiredPayload({ ...desiredPayload, [k]: value });
        }
        else {
            debug && console.log('do something with err');
        }
    };
    return (_jsxs(TableRow, { children: [_jsx(TableCell, { style: { width: keyWidth }, children: camelToDisplay(k) }, `key`), _jsx(TableCell, { style: { width: inputWidth }, children: v }, `val`), _jsx(TableCell, { style: { width: inputWidth }, children: _jsx(Input, { type: 'number',
                    style: { width: inputWidth },
                    value: desiredPayload?.[k] ?? 0,
                    onChange: (e) => {
                        setHasEdits(true);
                        handleNumberChange(e, k);
                    } }) }, `input`), _jsx(TableCell, { style: { width: inputWidth }, children: _jsx(Slider, { value: currentValue ?? min,
                    marks,
                    min,
                    max,
                    step,
                    color: 'secondary',
                    getAriaValueText: (v, i) => v.toString(),
                    'aria-labelledby': 'discrete-slider',
                    valueLabelDisplay: 'auto',
                    onChangeCommitted: (e, sVal) => {
                        e.preventDefault();
                        e.stopPropagation();
                        sVal = sVal instanceof Array ? sVal[0] : sVal;
                        setHasEdits(true);
                        setDesiredPayload({ ...desiredPayload, [k]: sVal });
                    } }) }, `slider`)] }, `r_${i}`));
}
